import React from "react";

const VARIANTS = {
  primary:
    "bg-gold text-ink-0 font-semibold hover:bg-gold-hover disabled:opacity-40 disabled:cursor-not-allowed shadow-[0_1px_0_0_rgba(255,255,255,0.06)_inset]",
  secondary:
    "bg-white/[0.04] text-white border border-white/10 hover:bg-white/[0.08] hover:border-white/15 disabled:opacity-40",
  ghost:
    "text-zinc-400 hover:text-white hover:bg-white/5 disabled:opacity-40",
  danger:
    "bg-red-500/10 text-red-300 border border-red-500/20 hover:bg-red-500/15 hover:text-red-200",
  gold_outline:
    "bg-gold/[0.06] text-gold border border-gold/25 hover:bg-gold/[0.12] hover:border-gold/40",
};

const SIZES = {
  xs: "text-xs px-2.5 py-1 rounded-md gap-1",
  sm: "text-xs px-3 py-1.5 rounded-md gap-1.5",
  md: "text-sm px-4 py-2 rounded-lg gap-2",
  lg: "text-sm px-5 py-2.5 rounded-lg gap-2",
  xl: "text-base px-6 py-3 rounded-lg gap-2",
};

export function Button({
  as: Comp = "button",
  variant = "primary",
  size = "md",
  className = "",
  children,
  icon: Icon,
  iconRight: IconRight,
  loading = false,
  disabled,
  ...props
}) {
  const base =
    "inline-flex items-center justify-center font-medium select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/60";
  const cls = `${base} ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${className}`;
  const style = { transitionProperty: "background-color, color, border-color, opacity", transitionDuration: "180ms" };
  const content = (
    <>
      {loading ? (
        <span className="w-3.5 h-3.5 rounded-full border-2 border-current border-t-transparent animate-spin" />
      ) : (
        Icon && <Icon className="w-4 h-4" strokeWidth={1.75} />
      )}
      {children && <span>{children}</span>}
      {IconRight && <IconRight className="w-4 h-4" strokeWidth={1.75} />}
    </>
  );
  return (
    <Comp className={cls} style={style} disabled={disabled || loading} {...props}>
      {content}
    </Comp>
  );
}

export default Button;
